var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("InputYearly", {
    attrs: {
      num_years: _vm.num_years,
      label: _vm.label,
      suffix: _vm.suffix,
      hint:
        "" +
        (_vm.hint ? _vm.hint + ". " : "") +
        (_vm.computedItemsType === "profile"
          ? "Enter a name to upload a new profile"
          : ""),
      type: "number",
      chart: _vm.profileDygraph,
      "table-input":
        !_vm.toggleItemsType && _vm.computedItemsType === "constant",
      "hide-label": _vm.hideLabel,
      "spread-values": _vm.spreadValues,
      "label-size": _vm.labelSize,
      fill: _vm.fill,
      "fill-value": _vm.fillValue,
      "extra-button": _vm.toggleItemsType,
      nullable: _vm.nullable,
      "start-year": _vm.startYear,
      repeat: _vm.repeat,
    },
    on: {
      "update:repeat": function ($event) {
        _vm.repeat = $event
      },
      "open-chart": function ($event) {
        _vm.queryProfiles = true
      },
      "close-chart": function ($event) {
        _vm.queryProfiles = false
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "extraButton",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _vm.toggleItemsType
                    ? _c(
                        "v-btn-toggle",
                        {
                          attrs: { color: "primary" },
                          model: {
                            value: _vm.computedItemsType,
                            callback: function ($$v) {
                              _vm.computedItemsType = $$v
                            },
                            expression: "computedItemsType",
                          },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                value: "constant",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "primary" } },
                                              [_vm._v("mdi-numeric")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4275514235
                              ),
                            },
                            [_c("span", [_vm._v("Constant values")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                value: "profile",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "primary" } },
                                              [
                                                _vm._v(
                                                  "mdi-chart-timeline-variant"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2084989381
                              ),
                            },
                            [_c("span", [_vm._v("Profiles")])]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.multiYearUpload
                    ? _c("DialogForm", {
                        attrs: { submit: _vm.submitMultiyear },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var dialogOn = ref.on
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var tooltipOn = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        color: "primary",
                                                      },
                                                    },
                                                    Object.assign(
                                                      {},
                                                      tooltipOn,
                                                      dialogOn
                                                    )
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("publish"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(" Upload multiyear profile "),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("InputCSV", {
                                    attrs: { "on-complete": _vm.saveMultiyear },
                                    on: {
                                      "file-selected": function ($event) {
                                        return _vm.setCSVName($event, "CSVName")
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var triggerUpload =
                                              ref.triggerUpload
                                            return [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Profile",
                                                  placeholder:
                                                    "Upload csv file",
                                                  readonly: "",
                                                  "append-icon": "publish",
                                                },
                                                on: {
                                                  click: triggerUpload,
                                                  "click:append": triggerUpload,
                                                },
                                                model: {
                                                  value: _vm.CSVName,
                                                  callback: function ($$v) {
                                                    _vm.CSVName = $$v
                                                  },
                                                  expression: "CSVName",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1761021941
                                    ),
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2529460770
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        (!_vm.nullable || (_vm.nullable && _vm.value)) &&
        _vm.computedItemsType === "profile"
          ? {
              key: "default",
              fn: function (ref) {
                var val = ref.value
                var year = ref.year
                var label = ref.label
                return [
                  _c("InputProfile", {
                    attrs: {
                      "profile-type": _vm.profileType,
                      suffix: _vm.suffix,
                      label: label,
                      "object-value": _vm.objectValue,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setYearValue($event, year - 1)
                      },
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: val[year - 1],
                      callback: function ($$v) {
                        _vm.$set(val, year - 1, $$v)
                      },
                      expression: "val[year - 1]",
                    },
                  }),
                ]
              },
            }
          : null,
      ],
      null,
      true
    ),
    model: {
      value: _vm.profiles,
      callback: function ($$v) {
        _vm.profiles = $$v
      },
      expression: "profiles",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }